/** Guias da ajuda (D-063): dados tipados, versionados junto com as telas. */
import type { Perfil } from '@metaepi/shared';

export interface ImagemGuia {
  /** Arquivo em public/ajuda/, gerado por `npm run ajuda:imagens` (D-066). */
  arquivo: string;
  /** Descrição para quem usa leitor de tela e para quando a imagem não carrega. */
  descricao: string;
}

export interface SecaoGuia {
  id: string;
  titulo: string;
  /** Um passo por item. **Negrito** marca botões, abas e campos. */
  passos: string[];
  /** Aviso ou explicação depois dos passos. */
  observacao?: string;
  /** Rótulos citados que precisam existir nas telas (D-065: o teste confere). */
  botoes?: string[];
  imagem?: ImagemGuia;
}

export interface Guia {
  id: string;
  titulo: string;
  resumo: string;
  /** Quem faz a tarefa. 'todos' para o guia de acesso. */
  perfis: readonly Perfil[] | 'todos';
  /** Abre sem login (só o guia de acesso). */
  publico?: boolean;
  /** Data da última revisão do texto (AAAA-MM-DD). */
  revisadoEm: string;
  secoes: SecaoGuia[];
}

export const guiaDoPerfil = (g: Guia, perfil: Perfil) =>
  g.perfis === 'todos' || g.perfis.includes(perfil);

/** Âncora de uma seção na página do guia (link do botão de ajuda e do sumário). */
export const ancoraSecao = (guia: string, secao: string) => `${guia}-${secao}`;
